import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    myChatWidget?: {
      load: (config: { assistantId: string; apiKey: string }) => void;
    };
  }
}

const AInsightsChatBot: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadChatWidget = () => {
      const script = document.createElement('script');
      script.type = "text/javascript";
      script.src = "https://agentivehub.com/production.bundle.min.js";
      script.async = true;
      script.onload = () => {
        if (!document.getElementById('root')) {
          const root = document.createElement('div');
          root.id = 'root';
          document.body.appendChild(root);
        }
        if (window.myChatWidget && typeof window.myChatWidget.load === 'function') {
          try {
            window.myChatWidget.load({
              assistantId: 'e9399508-b3f2-47e8-88d6-dd7403787890', // Correct AInsights assistant ID
              apiKey: '5e9fc760-d861-45eb-8095-72159f99cdf4', // Correct API key
            });
            setIsLoading(false);
          } catch (err) {
            setError('Failed to initialize chat widget');
            setIsLoading(false);
          }
        } else {
          setError('Chat widget not available');
          setIsLoading(false);
        }
      };
      script.onerror = () => {
        setError('Failed to load chat widget script');
        setIsLoading(false);
      };
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    };

    loadChatWidget();

    return () => {
      // Cleanup function if needed
    };
  }, []);

  if (isLoading) {
    return <div className="chatbot-loading">Loading AInsights chat bot...</div>;
  }

  if (error) {
    return <div className="chatbot-error">{error}</div>;
  }

  return (
    <div>
      <h1>AInsights ChatBot</h1>
      <div id="chatbot-container" className="fullscreen" />
    </div>
  );
};

export default AInsightsChatBot;